export default {
  id: "",
  isVisible: false,
  name: "",
  tickets: []
}
